import React from 'react';

import Link from '@atlaskit/link/link';

export default function NewWindow(): React.JSX.Element {
	return (
		<Link href="https://www.atlassian.com" target="_blank">
			Atlassian home
		</Link>
	);
}
